import { RefreshCw, X, Loader2 } from "lucide-react";
import { useAppUpdate } from "../lib/useAppUpdate";

export function AppUpdatePrompt() {
  const { needRefresh, isUpdating, applyUpdate, dismissUpdate } =
    useAppUpdate();

  if (!needRefresh) {
    return null;
  }

  return (
    <div className="fixed bottom-[calc(4.5rem+env(safe-area-inset-bottom,0px))] left-3 right-3 z-40 mx-auto max-w-md animate-slide-up">
      <div className="flex items-center gap-3 rounded-xl bg-accent px-4 py-2.5 text-accent-foreground shadow-lg">
        <RefreshCw className="h-4 w-4 flex-shrink-0" />
        <span className="flex-1 text-sm font-medium">Update available</span>
        <button
          onClick={applyUpdate}
          disabled={isUpdating}
          className="flex-shrink-0 rounded-lg bg-accent-foreground/20 px-3 py-1 text-sm font-semibold transition-colors hover:bg-accent-foreground/30 disabled:opacity-60"
        >
          {isUpdating ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            "Refresh"
          )}
        </button>
        <button
          onClick={dismissUpdate}
          className="flex-shrink-0 rounded-lg p-1 transition-colors hover:bg-accent-foreground/20"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
